// packages/front/src/portfolio/use-display-currency.ts
//
// useDisplayCurrency — hook that returns the display currency for the selected portfolio.
// displayCurrency is stored on the portfolio record and fetched via usePortfolios.

import { useMemo } from "react";
import { usePortfolios } from "./portfolio.hooks";
import { DISPLAY_CURRENCY, type TDisplayCurrency } from "@signals/shared";

/**
 * Returns the display currency for the given portfolio ID.
 * Falls back to "USD" if the portfolio is not found or still loading.
 */
export function useDisplayCurrency(portfolioId: string | undefined): {
  displayCurrency: TDisplayCurrency;
  isLoading: boolean;
} {
  const { data, isLoading } = usePortfolios();

  const displayCurrency = useMemo<TDisplayCurrency>(() => {
    if (!data?.items || !portfolioId) return "USD";
    const portfolio = data.items.find((p) => p.id === portfolioId);
    return (
      DISPLAY_CURRENCY.find(
        (currency) => currency === portfolio?.displayCurrency,
      ) ?? "USD"
    );
  }, [data, portfolioId]);

  return { displayCurrency, isLoading };
}
